module.exports = __webpack_public_path__ + "static/sprite-1055125d683cdfa57df95d9eaedfa9b1.jpeg";